/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Acc_Type_Individual_DescInputs */

const en_acc_type_individual_desc = /** @type {(inputs: Acc_Type_Individual_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freelancer, influencer, or solo seller.`)
};

const es_acc_type_individual_desc = /** @type {(inputs: Acc_Type_Individual_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freelancer, influencer o vendedor independiente.`)
};

const fr_acc_type_individual_desc = /** @type {(inputs: Acc_Type_Individual_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freelance, influenceur ou vendeur solo.`)
};

const de_acc_type_individual_desc = /** @type {(inputs: Acc_Type_Individual_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freelancer, Influencer oder Solo-Verkäufer.`)
};

const id_acc_type_individual_desc = /** @type {(inputs: Acc_Type_Individual_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pekerja lepas, pemengaruh, atau penjual solo.`)
};

/** @type {(inputs: Acc_Type_Individual_DescInputs) => LocalizedString} */
const ja_acc_type_individual_desc = en_acc_type_individual_desc;

/** @type {(inputs: Acc_Type_Individual_DescInputs) => LocalizedString} */
const zh_acc_type_individual_desc = en_acc_type_individual_desc;

/** @type {(inputs: Acc_Type_Individual_DescInputs) => LocalizedString} */
const ar_acc_type_individual_desc = en_acc_type_individual_desc;

/** @type {(inputs: Acc_Type_Individual_DescInputs) => LocalizedString} */
const it_acc_type_individual_desc = en_acc_type_individual_desc;

/** @type {(inputs: Acc_Type_Individual_DescInputs) => LocalizedString} */
const ru_acc_type_individual_desc = en_acc_type_individual_desc;

/** @type {(inputs: Acc_Type_Individual_DescInputs) => LocalizedString} */
const pt_acc_type_individual_desc = en_acc_type_individual_desc;

/** @type {(inputs: Acc_Type_Individual_DescInputs) => LocalizedString} */
const ko_acc_type_individual_desc = en_acc_type_individual_desc;

/**
* | output |
* | --- |
* | "Freelancer, influencer, or solo seller." |
*
* @param {Acc_Type_Individual_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const acc_type_individual_desc = /** @type {((inputs?: Acc_Type_Individual_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Acc_Type_Individual_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_acc_type_individual_desc(inputs)
	if (locale === "es") return es_acc_type_individual_desc(inputs)
	if (locale === "fr") return fr_acc_type_individual_desc(inputs)
	if (locale === "de") return de_acc_type_individual_desc(inputs)
	if (locale === "ja") return ja_acc_type_individual_desc(inputs)
	if (locale === "zh") return zh_acc_type_individual_desc(inputs)
	if (locale === "ar") return ar_acc_type_individual_desc(inputs)
	if (locale === "id") return id_acc_type_individual_desc(inputs)
	if (locale === "it") return it_acc_type_individual_desc(inputs)
	if (locale === "ru") return ru_acc_type_individual_desc(inputs)
	if (locale === "pt") return pt_acc_type_individual_desc(inputs)
	return ko_acc_type_individual_desc(inputs)
});